export interface Article {
  slug: string;
  comicSlug: string;
}

export const articleContents: Record<string, {
  title: string;
  author: string;
  coverImage: string;
  category: string;
  rating: number;
  ratingCount: number;
  status: string;
  tags: string[];
  summary: string;
  content: string;
  faqs: { question: string; answer: string }[];
}> = {
  'the-remarried-empress': {
    title: '再婚皇后',
    author: 'Alphatart / Sumpul',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20illustration%20of%20an%20elegant%20queen%20with%20long%20flowing%20hair%20wearing%20a%20regal%20golden%20gown%2C%20soft%20watercolor%20background%20with%20warm%20tones%2C%20romantic%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20composition%20on%20light%20cream%20backdrop&width=600&height=800&seq=article-remarried-empress&orientation=portrait',
    category: 'love',
    rating: 4.8,
    ratingCount: 32500,
    status: '连载中',
    tags: ['宫廷', '恋爱', '逆袭', '女性向'],
    summary: '皇后娜菲尔在离婚后选择再婚，她的选择震惊了整个帝国。面对前夫的后悔和新婚丈夫的宠爱，她将如何书写自己的命运？这部作品以精致的画风和细腻的情感描写赢得了大量读者的喜爱。',
    content: `
      <p>《再婚皇后》是韩国漫画家 Alphatart 与 Sumpul 联手创作的人气宫廷恋爱漫画，自连载以来在全球范围内积累了超高人气。</p>
      
      <h2>剧情简介</h2>
      <p>娜菲尔是东大帝国的完美皇后，她一直以来都尽职尽责地辅佐着皇帝索维舒。然而，索维舒却带回了一个名叫拉丝塔的妾室，并且公开表示对她的偏爱。面对皇帝的背叛，娜菲尔做出了一个震惊帝国的决定——她提出了离婚。</p>
      <p>离婚后，娜菲尔并没有消沉，而是选择嫁给邻国的国王海因里。这位年轻英俊的国王对娜菲尔宠爱有加，而前夫索维舒却在失去后才追悔莫及。一场关于爱情、尊严与成长的宫廷大戏就此展开。</p>

      <h2>角色介绍</h2>
      <h3>娜菲尔·特罗维</h3>
      <p>东大帝国的皇后，聪慧、优雅、果敢。面对丈夫的背叛，她选择了体面的离开，展现出现代女性的独立与自尊。她的成长轨迹是整部作品的核心看点。</p>
      
      <h3>海因里·拉兹罗</h3>
      <p>西王国的年轻国王，英俊潇洒，深情专一。他对娜菲尔的宠爱毫无保留，是读者心目中理想型的完美男主。</p>
      
      <h3>索维舒·特罗维</h3>
      <p>东大帝国的皇帝，娜菲尔的前夫。在失去后才懂得珍惜，他的后悔与嫉妒为故事增添了大量戏剧性。</p>

      <h2>为什么推荐这部作品？</h2>
      <p>首先，画风极其精美。Sumpul 的作画风格华丽细腻，人物造型和服装设计都堪称一流水准。每一话的封面都可以直接用作壁纸。</p>
      <p>其次，剧情节奏把控得当。不拖沓不注水，每个情节都有其存在的意义。感情线的发展自然流畅，没有突兀的转折。</p>
      <p>最重要的是，女主角的人设非常讨喜。娜菲尔不是等待拯救的公主，而是一个有主见、有能力的独立女性。她的选择和行为都充满了智慧和魅力。</p>

      <h2>读者评价</h2>
      <p>截至目前，《再婚皇后》在全球各大漫画平台上的评分均保持在 4.8 分以上，累计阅读量突破千万。读者们纷纷表示："每一话都看得心潮澎湃"、"海因里就是完美男主的标杆"、"娜菲尔的成长让人感动"。</p>

      <h2>阅读建议</h2>
      <p>本作品适合喜欢宫廷恋爱、女性成长、逆袭爽文的读者。画风精美，剧情紧凑，是入坑韩漫的绝佳选择。目前已更新至 185 话，建议从第一话开始阅读以获得完整体验。</p>
    `,
    faqs: [
      { question: '《再婚皇后》是免费韩漫吗？', answer: '是的，《再婚皇后》在多个正版韩漫平台上提供免费阅读，每周定期更新。支持无删减下拉式韩漫免费阅读体验。' },
      { question: '《再婚皇后》一共有多少话？', answer: '截至最新更新，《再婚皇后》已更新至第 185 话，仍在连载中。' },
      { question: '《再婚皇后》适合什么类型的读者？', answer: '本作品特别适合喜欢宫廷恋爱题材、女性独立成长故事的读者。画风唯美，剧情紧凑，是韩漫入门的优秀选择。' },
      { question: '《再婚皇后》是否有动画化计划？', answer: '目前官方尚未公布动画化的具体计划，但由于作品的高人气，粉丝对此充满期待。' },
    ],
  },
  'solo-leveling': {
    title: '我独自升级',
    author: 'Chugong / DUBU',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20powerful%20dark%20haired%20Korean%20manhwa%20character%20with%20purple%20glowing%20eyes%20and%20shadow%20army%20behind%20him%2C%20action%20pose%2C%20dramatic%20lighting%2C%20dark%20atmosphere%2C%20clean%20composition%20on%20dark%20gradient%20backdrop&width=600&height=800&seq=article-solo-leveling&orientation=portrait',
    category: 'action',
    rating: 4.9,
    ratingCount: 89500,
    status: '已完结',
    tags: ['战斗', '升级', '魔幻', '热血'],
    summary: '被称作"人类最弱兵器"的成振宇，在一次双重地下城事件后获得了"系统"，从此开启了不断变强的道路。这是近年来全球最火爆的韩漫作品之一。',
    content: `
      <p>《我独自升级》由 Chugong 原作、DUBU（REDICE STUDIO）作画，是近年来全球范围内影响力最大的韩漫作品之一。2024年动画化后更是引发了一波全球热潮。</p>
      
      <h2>剧情简介</h2>
      <p>故事发生在一个出现了"门"和"猎人"的世界。成振宇是 E 级猎人，被称为"人类最弱兵器"。在一次几乎全员覆没的双重地下城事件中，他奇迹般地活了下来，并获得了神秘的"系统"。</p>
      <p>通过系统，成振宇可以像玩游戏一样升级变强。从最弱的 E 级到超越 S 级的存在，他一步步揭开了隐藏在幕后的巨大秘密。</p>

      <h2>角色介绍</h2>
      <h3>成振宇</h3>
      <p>本作主角，从一个弱小的猎人成长为最强的"影之君主"。他的成长历程充满了热血与感动，是韩漫史上最具魅力的主角之一。</p>
      
      <h3>车慧仁</h3>
      <p>S 级猎人，成振宇的重要伙伴之一。她见证了振宇从弱小到强大的全过程，两人之间也萌生了微妙的情愫。</p>

      <h2>为什么全球爆火？</h2>
      <p>《我独自升级》的成功绝非偶然。首先，DUBU 的画功堪称教科书级别，战斗场面的分镜和表现力在整个韩漫界都属顶尖。</p>
      <p>其次，"打怪升级"的核心设定让读者获得了极强的代入感和爽感。看着主角一步步变强，碾压曾经瞧不起他的人，这种爽快感令人欲罢不能。</p>
      <p>此外，完整的世界观设定和层层递进的悬疑元素也为作品增添了深度。</p>

      <h2>读者评价</h2>
      <p>全球评分 4.9 分，累计阅读量超过 5600 万。作为衡量韩漫全球影响力的标杆之作，《我独自升级》已经成为一种文化现象。</p>
    `,
    faqs: [
      { question: '《我独自升级》完结了吗？', answer: '是的，《我独自升级》全 179 话已完结，可以一口气看完，享受完整的阅读体验。' },
      { question: '《我独自升级》有续作吗？', answer: '有！续作《我独自升级：Ragnarok》正在连载中，讲述了成振宇儿子的故事。' },
      { question: '《我独自升级》的动画在哪里看？', answer: '动画版由 A-1 Pictures 制作，在各大流媒体平台均有播出。' },
      { question: '《我独自升级》适合新人入坑吗？', answer: '非常适合！节奏紧凑、画风精良、剧情爽快，是很多读者的韩漫入坑之作。' },
    ],
  },
  'who-made-me-a-princess': {
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20princess%20with%20long%20blonde%20hair%20and%20sparkling%20blue%20eyes%20wearing%20a%20pink%20royal%20dress%2C%20surrounded%20by%20flowers%2C%20soft%20dreamy%20atmosphere%2C%20romantic%20manhwa%20style%2C%20clean%20composition%20on%20light%20cream%20backdrop&width=600&height=800&seq=article-princess&orientation=portrait',
    category: 'love',
    rating: 4.8,
    ratingCount: 42100,
    status: '已完结',
    tags: ['穿越', '父女', '治愈', '皇室'],
    summary: '一觉醒来变成了小说中注定死亡的公主阿西娅，为了改变命运，她决定攻略那个冷酷无情的父皇克劳德。这是一部让人笑中带泪的治愈系佳作。',
    content: `
      <p>《某天成为公主》由 Plutus 原作、Spoon 作画，是最受欢迎的韩漫穿越类作品之一，以温馨治愈的父女情感动了全球数以千万的读者。</p>
      
      <h2>剧情简介</h2>
      <p>现代女性一觉醒来发现自己穿越到了正在阅读的小说《可爱的公主》中，变成了注定要被亲生父亲——皇帝克劳德处死的公主阿西娅。</p>
      <p>为了改变悲惨的命运，阿西娅决定用自己的可爱和真诚去攻略那个冷酷无情的父皇。然而，在这个过程中，她发现克劳德的冷酷背后隐藏着深深的伤痛。</p>

      <h2>角色介绍</h2>
      <h3>阿西娅</h3>
      <p>穿越成为公主的女主角，拥有成年人的心智和孩童的身体。她用自己的聪明才智和真诚感动了身边的每一个人。</p>
      
      <h3>克劳德</h3>
      <p>阿西娅的父皇，帝国最强大的魔法师。表面冷酷无情，实则内心柔软。被阿西娅的真诚打动后，成为了世上最宠女儿的"女儿奴"。这个角色的转变是整部作品最动人的部分。</p>

      <h2>作品的魅力何在？</h2>
      <p>《某天成为公主》最打动人心的是父女之间纯粹的感情。克劳德从冷漠到宠溺的转变过程细腻而感人，无数读者表示"每一话都在笑着流泪"。</p>
      <p>Spoon 的画风极具表现力，阿西娅的可爱表情和克劳德的帅气形象都深入人心。尤其是那些温馨的互动场景，每一帧都美得像艺术品。</p>

      <h2>读者评价</h2>
      <p>全 125 话已完结，评分 4.8 分，累计阅读超 3100 万。被读者誉为"韩漫史上最治愈的父女故事"。</p>
    `,
    faqs: [
      { question: '《某天成为公主》完结了吗？', answer: '是的，全 125 话已完结，可以放心入坑。结局温馨圆满，不会烂尾。' },
      { question: '《某天成为公主》有感情线吗？', answer: '主线是父女亲情，后期有淡淡的恋爱线，但父女互动始终是最核心的部分。' },
      { question: '《某天成为公主》和《某天成为王的女儿》是同一部吗？', answer: '是的，不同的翻译名称，指的都是同一部作品。' },
    ],
  },
  'eleceed': {
    title: '超能觉醒',
    author: '孙济好 / ZHENA',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cute%20fat%20cat%20with%20electric%20powers%20in%20Korean%20webtoon%20style%20next%20to%20a%20young%20male%20protagonist%2C%20action%20adventure%20theme%2C%20bright%20colorful%20atmosphere%2C%20humor%20and%20action%20blend%2C%20clean%20composition&width=600&height=800&seq=article-eleceed&orientation=portrait',
    category: 'fantasy',
    rating: 4.8,
    ratingCount: 37800,
    status: '连载中',
    tags: ['异能', '猫', '热血', '搞笑'],
    summary: '拥有超能力的少年纪元与一只会发电的肥猫相遇后，被卷入了一个充满异能者的隐藏世界。战斗热血、日常搞笑，还有可爱的猫咪，集齐了所有让人喜欢的元素。',
    content: `
      <p>《超能觉醒》（Eleceed）由孙济好原作、ZHENA 作画，是近年最受欢迎的韩漫动作喜剧之一。独特的"猫+异能"设定让它在同类作品中脱颖而出。</p>
      
      <h2>剧情简介</h2>
      <p>纪元是一个拥有超速度能力的少年，但他一直隐藏着自己的能力，过着普通的高中生活。直到有一天，他遇到了一只被追杀的、会发电的肥猫——凯登。</p>
      <p>凯登其实是异能界最强的觉醒者之一，因为某些原因变成了猫的形态。纪元救助了凯登后，两人结下了深厚的友谊，纪元也被卷入了异能者的世界。</p>

      <h2>角色介绍</h2>
      <h3>纪元</h3>
      <p>男主角，性格开朗善良，拥有超速度能力。在凯登的指导下不断成长，逐渐成为异能界不可忽视的新星。</p>
      
      <h3>凯登</h3>
      <p>一只会发电的肥猫（实际上是异能界最强觉醒者），傲娇又可爱，是作品的灵魂角色。和纪元的互动充满了搞笑和温馨。</p>

      <h2>为什么推荐？</h2>
      <p>《超能觉醒》最大的亮点是它的平衡性——战斗场面热血燃炸，日常剧情搞笑治愈，两者之间切换自然流畅。</p>
      <p>猫咪凯登的存在为作品增添了无限萌点。一只又肥又能打的猫，谁会不喜欢呢？</p>
      <p>画风方面，战斗场面的分镜和特效都非常出色，动作流畅度和冲击力在韩漫中属于一流水准。</p>

      <h2>读者评价</h2>
      <p>评分 4.8 分，已更新至 300 话，每周稳定更新。读者评价："又燃又萌的神作"、"凯登是最有魅力的猫"。</p>
    `,
    faqs: [
      { question: '《超能觉醒》在哪些平台可以免费阅读？', answer: '在多个正版韩漫平台上都可以免费阅读《超能觉醒》，支持无删减下拉式韩漫阅读，每周更新一话。' },
      { question: '《超能觉醒》的主角猫是什么品种？', answer: '凯登在漫画中是一只橘色的肥猫，虽然品种未明确说明，但形象非常讨喜。' },
      { question: '《超能觉醒》和《外貌至上主义》是同一个作者吗？', answer: '不是，《超能觉醒》的原作者是孙济好，画师是 ZHENA，与《外貌至上主义》的作者不同。' },
    ],
  },
  'omniscient-reader': {
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20protagonist%20reading%20a%20book%20while%20the%20apocalyptic%20world%20collapses%20around%20him%2C%20dramatic%20contrast%2C%20fantasy%20survival%20theme%2C%20intense%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=article-omniscient&orientation=portrait',
    category: 'fantasy',
    rating: 4.9,
    ratingCount: 52100,
    status: '连载中',
    tags: ['末世', '系统', '生存', '智斗'],
    summary: '当连载了十年的小说变成现实，唯一读完结局的金独子成为了这个末日世界中最特殊的存在。以"读者"的身份介入故事的展开，这是近年来最具创意的韩漫设定之一。',
    content: `
      <p>《全知读者视角》由 sing N song 原作、Sleepy-C 作画，凭借极具创意的设定和扣人心弦的剧情，在全球范围内获得了极高评价，被誉为"改变韩漫格局的作品"。</p>
      
      <h2>剧情简介</h2>
      <p>金独子是一名普通的上班族，十年来他唯一坚持的事情就是追更网络小说《在灭亡世界生存的三种方法》。在小说完结的当天，小说中的末日场景竟然在现实中上演了。</p>
      <p>作为世界上唯一知道故事走向的人，金独子运用自己的"全知"优势，在这个残酷的末日世界中引导着故事的发展。然而，他的行为也在悄然改变着故事的走向……</p>

      <h2>角色介绍</h2>
      <h3>金独子</h3>
      <p>男主角，"全知读者"。他不是一个传统的热血主角，而是依靠智慧和情报来应对危机。他的冷静、机智和对故事人物的感情，使他成为极富深度的主角。</p>
      
      <h3>刘众赫</h3>
      <p>小说原定的主角，回归者。强大而冷酷，按照小说设定他应该是拯救世界的人，但金独子的介入改变了一切。</p>

      <h2>独特之处</h2>
      <p>《全知读者视角》最大的魅力在于它的"元叙事"结构。读者（金独子）与主角（刘众赫）之间的关系、读者与故事之间的关系，都被巧妙地融入了剧情中。</p>
      <p>作品探讨了"故事的意义"、"读者与角色的羁绊"等深刻主题，远不止是一部简单的末世生存漫画。</p>
      <p>Sleepy-C 的画风极具辨识度，战斗场面华丽震撼，角色表情丰富细腻。</p>

      <h2>读者评价</h2>
      <p>评分 4.9 分，已更新至 230 话。读者评价："设定太绝了"、"每一话都在刷新认知"、"韩漫天花板"。累计阅读量突破 4200 万。</p>
    `,
    faqs: [
      { question: '《全知读者视角》完结了吗？', answer: '目前仍在连载中，已更新至第 230 话。每周定期更新，建议收藏追更。' },
      { question: '《全知读者视角》和《我独自升级》哪个更好看？', answer: '两部都是顶级韩漫，各有特色。《全知读者视角》更重智斗和剧情深度，《我独自升级》更重爽感和战斗。两部都值得一看！' },
      { question: '《全知读者视角》小说和漫画有什么区别？', answer: '漫画在小说基础上进行了精炼和视觉化呈现，画风精美，节奏更适合漫画阅读。小说则提供了更丰富的细节描写。' },
    ],
  },
};

export const getArticleBySlug = (slug: string) => articleContents[slug];